<template>
  <div class="container">
    <div class="page-title">
        mOS in Subgroups Based on Clinical<br/>
        Characteristics and Response
    </div>
    <ul style="margin-top:50px">
      <li>
          In Cohort 1, patients with poor prognostic factors such as visceral or liver metastases or ECOG PS 2 tended to have shorter median OS
      </li>
    </ul>
    <img class="cover" src="../../assets/step5/map3.jpg" alt="">
    <small class="foot-small">
        Error bars represent 95% CIs. Median durations that are not estimable are indicated as NE.<br/>
mOS, median overall survival.<br/>
a Upper 95% CI is NE.
    </small>
    <foot-component text=""></foot-component>
    <template>
      <router-link to="/step5-5" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link
      to="/step5-7" class="btn-next el-icon-arrow-right"></router-link>
    </template>
  </div>
</template>

<script>
import footText from './footText'
export default {
  name: 'page7',
  components: {
    'foot-component': footText
  }
}
</script>

<style scoped>
.page-title {
  color:#1367a2;letter-spacing:.5pt;
  margin:0;margin-bottom:10px;font-size:18px;
  font-weight:bold;
}
.cover {width:100%;margin:50px 0;}
.foot-small {
  color:#666666;letter-spacing:.4pt;margin-bottom:150px;
  display:block;
}
a[class*="btn-"]{
  background:#1367a2;color:white;
}
a.btn-next {right:0;}

@media(max-width:750px){
  .container,
  .foot-small {width:90%;margin:20px auto;margin-left:5%;}
  a.btn-next {right:10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/step5/page7.vue